<div class="cellar-component container">
  <div class="categories" fxLayout="row wrap" fxLayoutAlign="start stretch">
    <mat-card class="types category" fxFlex="45">
      <mat-card-header>
        <div
          class="header-container"
          fxLayout="row"
          fxLayoutAlign="space-between center"
          fxFlex="100"
        >
          <mat-toolbar>
            <div class="title" mat-card-title>
              <span style="margin-left: 10px">اندازه‌های چاپ </span>
            </div>
          </mat-toolbar>
        </div>
      </mat-card-header>

      <mat-card-content>
        <div
          fxFlex="100"
          fxLayout="column"
          class="cellar-content"
          fxLayoutAlign="space-between"
        >
          <div class="type-holder">
            <mat-nav-list>
              <a
                (click)="openTypeEdit(key)"
                mat-list-item
                *ngFor="let key of getTypingsKeys(); first as isFirst"
              >
                <span
                  matListItemTitle
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                >
                  سایز {{ key }}
                  <jam-icon name="pen" color="accent" />
                </span>
              </a>

            </mat-nav-list>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="bindings category" fxFlex="45">
      <mat-card-header>
        <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
          <span>صحافی‌ها</span>
          <button id="addNewBinding" (click)="openBindingAdd()" mat-button>
            <jam-icon
              name="plus"
              vertical-align="middle"
              [size]="26"
              style="cursor: pointer"
            />
          </button>
        </mat-toolbar>
      </mat-card-header>

      <mat-card-content>
        <div
          fxFlex="100"
          fxLayout="column"
          class="cellar-content"
          fxLayoutAlign="space-between"
        >
          <div class="type-holder">
            <mat-nav-list>
              <a
              (click)="openBindingEdit('bindingSalaryFee')"
              mat-list-item

            >
              <span
                matListItemTitle
                fxLayout="row"
                fxLayoutAlign="space-between center"
              >
                 دستمزد ثابت صحافی
                <jam-icon name="pen" color="accent" />
              </span>
            </a>
              <a
                mat-list-item
                *ngFor="let binding of bindings; first as isFirst"
                (click)="openBindingEdit(binding.id)"
              >
                <span
                  fxLayout="row"
                  matListItemTitle
                  fxLayoutAlign="space-between center"
                >
                  {{ binding.name }} - {{ binding.type || 'عمومی' }}
                  <jam-icon name="pen" color="accent" />
                </span>
              </a>
            </mat-nav-list>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card class="bindings category" fxFlex="45">
      <mat-card-header>
        <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
          <span>رنگ‌ها</span>
          <button id="addNewColor" (click)="openColorAdd()" mat-button>
            <jam-icon
              name="plus"
              color="warn"
              vertical-align="middle"
              [size]="26"
              style="cursor: pointer"
            />
          </button>
        </mat-toolbar>
      </mat-card-header>

      <mat-card-content>
        <div
          fxFlex="100"
          fxLayout="column"
          class="cellar-content"
          fxLayoutAlign="space-between"
        >
          <div class="type-holder">
            <mat-nav-list>
              <a
                mat-list-item
                *ngFor="let color of talcColors; first as isFirst"
                (click)="openColorEdit(color.id)"
              >
                <span
                  fxLayout="row"
                  matListItemTitle
                  fxLayoutAlign="space-between center"
                >
                  طلق {{ color.name }}
                  <app-talc-color
                    [colorCode]="color.colorCode"
                  />
                </span>
              </a>
            </mat-nav-list>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
